import { useState, useEffect } from 'react'
import { supabase } from '../../../../supabase'
import AnalysisCard from '../analysisCard'

function PreviousAnalysis({trigger}) {
  const [analysis, setAnalysis] = useState([])

  useEffect(() => {
    const fetchAnalysis = async () => {
      const { data, error } = await supabase
      .from('analysis-test')
      .select('*')
      .order('created_at', { ascending: false }) // ou true
      .limit(5);
      if (error) {
        console.error('Error fetching analysis:', error);
      } else {
        if (data.length >= 1) {
          setAnalysis(data)
        }
      }
    };
    // fetchAnalysis();
  }, []);

  return (
    <div className='mt-5 flex'>
      <div className='flex flex-wrap gap-4'>
        {analysis.map((analysis) => (
          <AnalysisCard key={analysis.id} data={analysis} />
        ))}
      </div>
    </div>
  )
}
export default PreviousAnalysis;
